import { useState } from "react"
import { Box, Button, Typography } from "@mui/material"
import dayjs from "dayjs"
import FormElement from "../../lib/FormElement"
import { collection, doc, getDoc, updateDoc } from "firebase/firestore"
import { db, functions } from "../../../firebase"
import { toast } from 'react-toastify'
import { setIndividualStatus } from "./common"
import { httpsCallable } from "firebase/functions"

type Props = {
  individualId: string,
  arrivalDatetime: Date,
}

export const ArrivalDatetime = (props: Props) => {
  const { individualId, arrivalDatetime } = props
  const [datetime, setDatetime] = useState<Date>(arrivalDatetime || new Date())
  const individualDoc = doc(collection(db, 'individuals'), individualId)
  const sendMail = httpsCallable(functions, 'sendMail')
  const mailTemplate = (id: string) => {
    return `
  施設到着を確認しました。
  以下リンクより個体情報の入力をお願いします。

  https://traceability.rindou.info/individuals/${id}/arrival/regist
  `
  }

  const onChange = ({value}) => {
    setDatetime(value)
  }
  const registDatetime = async () => {
    const doc = await getDoc(individualDoc)
    await updateDoc(individualDoc, setIndividualStatus({ ...doc.data(), arrivalDatetime: dayjs(datetime).format('YYYY/MM/DD HH:mm'), updatedAt: dayjs().format('YYYY/MM/DD HH:mm') }))
      .then(async () => {
        await sendMail({
          to: doc.data()?.email,
          subject: "[りんどう] 施設到着個体情報の入力をお願いします",
          type: "text",
          contents: mailTemplate(individualId)
        })
        toast.success("施設到着を登録しました")
      }).catch(e => {
        toast.error(e)
      })
  }

  return (
    <Box display="contents" justifyContent="center">
      {
        arrivalDatetime ?
          <Typography>{dayjs(datetime).format('YYYY/MM/DD HH:mm')}</Typography> :
          <Box display="flex" alignItems="center">
            <FormElement
              type="datetime"
              name=""
              value={datetime}
              onChange={onChange}
              text="施設到着日時"
            />
            <Button variant="contained" color="success" size="large" onClick={() => registDatetime()}>到着</Button>
          </Box>
      }
    </Box>
  )
}
